import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import Chart from 'react-google-charts';
import Card from '../../Cards';
import FilterDropdown from '../../Modal/FilterDropdown';
import { countBy, getDate, getChartData } from './DatesAnalytics';
import moment from 'moment';
//import { extendMoment } from 'moment-range';

//const moment = extendMoment(Moment);
let weekStart = moment().startOf('week');
let weekDays = [];
for (let i = 0; i <= 6; i++) {
  weekDays.push(moment(weekStart).add(i, 'days').format('dddd D'));
}

export default function ChartViews({ analyticsViewProfile }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [option, setOption] = useState('week');
  const [apply, setApply] = useState(false);

  const initial = getChartData(analyticsViewProfile, 'views', 'week');
  const [data, setData] = useState(initial);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    //console.log('card ref', cardRef.current.getAttribute('name'));
  };

  const handleOption = (event, option) => {
    setApply(false);
    setOption(option);
    setData(getChartData(analyticsViewProfile, 'views', option));
    setAnchorEl(null);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <>
      <FilterDropdown
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        handleOption={handleOption}
        option={option}
      />
      <div style={{ margin: '24px 0', height: 368 }}>
        <Card
          title="Visitas a tu perfil"
          subtitle1={getDate(option)}
          subtitle2={`${countBy(option, analyticsViewProfile)} visitas`}
          filter={true}
          dropdown={handleClick}
        >
          <Chart
            width={'100%'}
            height={'250px'}
            chartType="ColumnChart"
            loader={<div style={{marginBottom:16}}>Cargando gráfica...</div>}
            data={data? 
              data : 
              [['Dia', 'Visitas', { role: 'style' }],
              [weekDays[0], 0, '#35b9b6'],
              [weekDays[1], 0, '#106c9d'],
              [weekDays[2], 0, '#35b9b6'],
              [weekDays[3], 0, '#106c9d'],
              [weekDays[4], 0, '#35b9b6'],
              [weekDays[5], 0, '#106c9d'],
              [weekDays[6], 0, '#35b9b6'],
            ]}
            options={{
              // Material design options
              maxWidth: '100%',
              Height: 300,
              chartArea: {
                width: '80%',
                height: '80%',
                top: 30,
                backgroundColor: 'transparent',
              },
              legend: { position: 'none' },
              hAxis: {
                textStyle: {
                  fontName: 'Lato',
                  bold: true,
                  color: '#10587f',
                  fontSize: 10,
                },
                baseline: {
                  color: '#e7e7e7',
                },
              },
              vAxis: {
                minValue: 10,
                format: 'decimal',
                textStyle: {
                  fontName: 'Lato',
                  bold: true,
                  color: '#10587f',
                  fontSize: 10,
                },
                gridlines: {
                  color: '#e7e7e7',
                },
                minorGridlines: {
                  color: '#e7e7e7',
                },
                baseline: {
                  color: '#e7e7e7',
                },
              },
              bar: { groupWidth: '50%' },
            }}
            // For tests
            rootProps={{ 'data-testid': '0' }}
          />
        </Card>
      </div>
    </>
  );
}
